import React, { SetStateAction } from 'react';
import { FormDefinitionOption } from '../../../common/types';
import { Select as VendorSelect } from '@check24/form';
import { SelectColumn } from './StyledUndefinedContractsElements';
import { TrackingClass } from '../../../Enums/TrackingClass';
import styled from 'styled-components';

type ProductSelectPropsType = {
    definition: any;
    activeProduct: any;
    setActiveProduct: SetStateAction<any>;
    setActiveSearchValue: SetStateAction<any>;
    activeSearchValue: any;
    setActiveProvider: SetStateAction<any>;
};

const StyledVendorSelectMobile = styled(VendorSelect.Mobile)`
    main {
        background-image: url('/img/angle-down-grey.svg');
        background-size: 16px 9px;

        select {
            color:#181818;
        }
    }

    label {
        color: #949494;
    }
`;

const ProductSelect = (props: ProductSelectPropsType) => {
    const { definition, activeProduct, setActiveProduct, setActiveSearchValue, setActiveProvider } = props;

    const handleChange = (options: string): void => {
        setActiveSearchValue('');
        setActiveProvider({});
        setActiveProduct(JSON.parse(options));
    };

    return (
        <>
            {definition.map((field: any, index: number) => {
                if (field.type !== 'select') {
                    return null;
                }

                const choices = [
                    { label: 'Bitte wählen', value: '{}' },
                    ...(field.options as FormDefinitionOption[]).map((option) => ({
                        label: option.label,
                        value: JSON.stringify(option),
                    })),
                ];

                return (
                    <SelectColumn key={`select_contract${index}`}>
                        <StyledVendorSelectMobile
                            choices={choices}
                            onChange={(value) => handleChange(value as string)}
                            value={JSON.stringify(activeProduct)}
                            label={'Vertrag'}
                            className={TrackingClass.PRODUCT_SELECT}
                        />
                    </SelectColumn>
                );
            })}
        </>
    );
};

export default ProductSelect;
